import type { Types } from '../types';
import type { OutTypes } from './schedules';
import { getVertexId } from '../util';
import { omitEdgesAndInternalProperties, type SerializedEdgesOnlyVertexExport, type SerializedEdgesShape } from './util';
import type { BaseOptions } from '../../common/types';
import type { GroupVertex } from '../interfaces/vertices/groups';

export default (
  groups:  Types.Mixed.Group[],
  options: BaseOptions
): OutTypes.group[] => {
  return groups
    .map(x => {
      const edges: SerializedEdgesOnlyVertexExport<GroupVertex> = {
        rootInterval: x.rootInterval ? getVertexId(x.rootInterval, options) : undefined,
        exceptions:   x.exceptions  ?.map(x => getVertexId(x, options)),
        lockedTimes:  x.lockedTimes ?.map(x => getVertexId(x, options)),
        lunch:        x.lunch       ?.map(x => getVertexId(x, options)),
        members:      x.members     ?.map(x => getVertexId(x, options)),
        parentGroups: x.parentGroups?.map(x => getVertexId(x, options)),
        subGroups:    x.subGroups   ?.map(x => getVertexId(x, options)),
      } satisfies SerializedEdgesShape<SerializedEdgesOnlyVertexExport<GroupVertex>>;
      const nonEdges = omitEdgesAndInternalProperties(x, edges);

      return { ...nonEdges, ...edges };
    });
};
